// extracted by mini-css-extract-plugin
export default {"address":"addReport_address__KLd2F","formFields":"addReport_formFields__HbXvq","corner_button":"addReport_corner_button__6Cs6e","display_text":"addReport_display_text__IhTo8"};